import React, { useState } from "react";
import BuscaAluno from "../../../../components/SearchStudents";
import api from "../../../../services/api";
import { fmtDateFull, todayISO } from "../../../../shared/utils";
export default function AdminBonus({
  students,
  teachers,
  bonusLog,
  setBonusLog,
  showFlash,
}) {
  const [tipo, setTipo] = useState("bonus"); // 'bonus' ou 'penalidade'
  const [form, setForm] = useState({
    aluno_id: 0,
    pts_rank: "",
    tokens: "",
    motivo: "",
    professor_id: 1,
  });
  const submit = async (event) => {
    event.preventDefault();
    const alunoId = Number(form.aluno_id);
    if (!alunoId) {
      showFlash("Selecione o aluno.", "er");
      return;
    }
    if (!form.motivo.trim()) {
      showFlash("Informe o motivo.", "er");
      return;
    }
    const valPts = parseInt(form.pts_rank) || 0;
    const valTok = parseInt(form.tokens) || 0;
    if (valPts === 0 && valTok === 0) {
      showFlash("Informe pelo menos Pontos ou Tokens.", "er");
      return;
    }
    // penalidade = valores negativos
    const value = tipo === "penalidade" ? -Math.abs(valPts) : Math.abs(valPts);
    const valueAtual2 =
      tipo === "penalidade" ? -Math.abs(valTok) : Math.abs(valTok);
    const student = students.find(
      (studentAtual2) => studentAtual2.id === alunoId,
    );
    if (!student) {
      showFlash("Aluno não encontrado.", "er");
      return;
    }
    try {
      const { data } = await api.post("/bonus-log", {
        aluno_id: alunoId,
        pontos_rank: value,
        tokens: valueAtual2,
        motivo: form.motivo.trim(),
        tipo,
        professor_id: Number(form.professor_id) || 1,
        data: todayISO(),
      });
      setBonusLog((prev) => [...prev, data.data]);
      showFlash(
        `${tipo === "bonus" ? "Bônus" : "Penalidade"} aplicado para ${student.nome}! Pontos: ${value >= 0 ? "+" : ""}${value} | Tokens: ${valueAtual2 >= 0 ? "+" : ""}${valueAtual2}`,
        "ok",
      );
      setForm((prev) => ({
        aluno_id: 0,
        pts_rank: "",
        tokens: "",
        motivo: "",
        professor_id: prev.professor_id,
      }));
    } catch (err) {
      showFlash(
        err.response?.data?.message || "Nao foi possivel aplicar o bonus.",
        "er",
      );
    }
  };
  return (
    <div>
      <div
        className="fc"
        style={{
          marginBottom: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 0,
            borderRadius: 10,
            overflow: "hidden",
            border: "2px solid #E0E8EB",
            marginBottom: 14,
          }}
        >
          <button
            type="button"
            onClick={() => setTipo("bonus")}
            style={{
              flex: 1,
              padding: "11px",
              border: "none",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              background: tipo === "bonus" ? "#4FB3A9" : "#FFF",
              color: tipo === "bonus" ? "#FFF" : "#6B8590",
              transition: "all .15s",
            }}
          >
            + Bônus
          </button>
          <button
            type="button"
            onClick={() => setTipo("penalidade")}
            style={{
              flex: 1,
              padding: "11px",
              border: "none",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              background: tipo === "penalidade" ? "#D9534F" : "#FFF",
              color: tipo === "penalidade" ? "#FFF" : "#6B8590",
              transition: "all .15s",
            }}
          >
            − Penalidade
          </button>
        </div>

        <div
          style={{
            fontSize: 12,
            color: "#6B8590",
            marginBottom: 12,
            padding: "8px 10px",
            background: "#F4F8F9",
            borderRadius: 8,
          }}
        >
          {tipo === "bonus"
            ? "Bônus: adiciona Pontos e/ou Tokens ao aluno."
            : "Penalidade: remove Pontos e/ou Tokens do aluno (informe os valores positivos abaixo)."}
        </div>

        <form onSubmit={submit}>
          <div className="fg">
            <label>Aluno *</label>
            <BuscaAluno
              students={students.filter((student) => student.ativo)}
              value={form.aluno_id}
              onChange={(value) =>
                setForm({
                  ...form,
                  aluno_id: value,
                })
              }
            />
          </div>
          <div className="fg">
            <label>Professor</label>
            <select
              className="sel"
              value={form.professor_id}
              onChange={(event) =>
                setForm({
                  ...form,
                  professor_id: event.target.value,
                })
              }
            >
              {teachers
                .filter((teacher) => teacher.ativo)
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nome}
                  </option>
                ))}
            </select>
          </div>
          <div className="fr">
            <div className="fg">
              <label>
                Pontos {tipo === "penalidade" ? "a remover" : "a adicionar"}
              </label>
              <input
                type="number"
                min="0"
                className="inp"
                value={form.pts_rank}
                onChange={(event) =>
                  setForm({
                    ...form,
                    pts_rank: event.target.value,
                  })
                }
                placeholder="0"
              />
            </div>
            <div className="fg">
              <label>
                Tokens {tipo === "penalidade" ? "a remover" : "a adicionar"}
              </label>
              <input
                type="number"
                min="0"
                className="inp"
                value={form.tokens}
                onChange={(event) =>
                  setForm({
                    ...form,
                    tokens: event.target.value,
                  })
                }
                placeholder="0"
              />
            </div>
          </div>
          <div className="fg">
            <label>Motivo *</label>
            <textarea
              className="tea"
              value={form.motivo}
              onChange={(event) =>
                setForm({
                  ...form,
                  motivo: event.target.value,
                })
              }
              style={{
                minHeight: 55,
              }}
              placeholder={
                tipo === "bonus"
                  ? "Ex: Participação exemplar, indicação bem-sucedida..."
                  : "Ex: Atraso sem justificativa, comportamento inadequado..."
              }
              required
            />
          </div>
          <button
            type="submit"
            className="btn"
            style={{
              background: tipo === "bonus" ? "#4FB3A9" : "#D9534F",
            }}
          >
            Aplicar {tipo === "bonus" ? "Bônus" : "Penalidade"}
          </button>
        </form>
      </div>

      <div className="dv dv-dark">
        <span>Histórico ({bonusLog.length})</span>
      </div>
      {bonusLog.length === 0 ? (
        <div className="es">
          <h3>Nenhum registro ainda</h3>
        </div>
      ) : (
        [...bonusLog].reverse().map((item) => {
          const student = students.find(
            (studentAtual2) => studentAtual2.id === item.aluno_id,
          );
          const teacher = teachers.find(
            (teacherAtual2) => teacherAtual2.id === item.professor_id,
          );
          const ehBonus =
            (item.pontos_rank || 0) >= 0 && (item.tokens || 0) >= 0;
          return (
            <div
              key={item.id}
              style={{
                background: "#FFF",
                borderRadius: 10,
                padding: "10px 13px",
                marginBottom: 6,
                borderLeft: `4px solid ${ehBonus ? "#4FB3A9" : "#D9534F"}`,
                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 8,
                }}
              >
                <div
                  style={{
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      marginBottom: 2,
                    }}
                  >
                    <span
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        padding: "1px 7px",
                        borderRadius: 999,
                        background: ehBonus ? "#E0F5F0" : "#FFE5E0",
                        color: ehBonus ? "#1A7A6E" : "#B83A2E",
                      }}
                    >
                      {ehBonus ? "BÔNUS" : "PENALIDADE"}
                    </span>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#1F4754",
                      }}
                    >
                      {student?.nome}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                    }}
                  >
                    {item.motivo}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#B8C5CC",
                      marginTop: 2,
                    }}
                  >
                    prof. {teacher?.nome} — {fmtDateFull(item.data)}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "right",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                      color:
                        (item.pontos_rank || 0) >= 0 ? "#FF8C42" : "#D9534F",
                    }}
                  >
                    {(item.pontos_rank || 0) >= 0 ? "+" : ""}
                    {item.pontos_rank || 0} pts
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: (item.tokens || 0) >= 0 ? "#4FB3A9" : "#D9534F",
                    }}
                  >
                    {(item.tokens || 0) >= 0 ? "+" : ""}
                    {item.tokens || 0} tok
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
export { AdminBonus };
